const { UPDATE_SMS_STATUS } = require('constants/actionTypes/user');

const updateSmsStatus = data => ({
    type: UPDATE_SMS_STATUS,
    payload: data
});

module.exports = {
    updateSmsStatus
};
